import React from 'react';

import FullWrapper from '../full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import Scrollbars from 'react-custom-scrollbars-2';

const PortfolioGallery = ({ imgList, className = '', smallPaddings = false, isMargin = true }) => {
    return (
        <FullWrapper
            caseName={`portfolio-gallery ${className}`}
            smallPaddings={smallPaddings}
            isMargin={isMargin}
        >
            <Scrollbars
                renderThumbVertical={props => (
                    <div {...props} className="portfolio-gallery__thumb-vertical" />
                )}
                style={{ maxWidth: 1400, height: '60vh' }}
            >
                <div className="portfolio-gallery__wrapper">
                    {imgList.map((item, index) => {
                        return (
                            <ScrollAnimation
                                animateIn="fadeInUp"
                                offset={50}
                                animateOnce={true}
                                duration={1}
                                className="portfolio-gallery__item"
                                key={index}
                            >
                                <img src={item} alt="" loading="lazy" />
                            </ScrollAnimation>
                        );
                    })}
                </div>
            </Scrollbars>
        </FullWrapper>
    );
};

export default PortfolioGallery;
